import type { ComponentType } from "react";
import type { LiveSeoContent as LiveSeoPageData } from "~/data/liveSeoContent.functions";
import { DefaultLiveSeoPage } from "./DefaultLiveSeoPage";
import { AccessibilityStatementPage } from "./pages/AccessibilityStatementPage";
import { BlogPage } from "./pages/BlogPage";
import { CareersPage } from "./pages/CareersPage";
import { ContactPage } from "./pages/ContactPage";
import { CovidPage } from "./pages/CovidPage";
import { FaqsPage } from "./pages/FaqsPage";
import { HappyHalloweenPage } from "./pages/HappyHalloweenPage";
import { InvisalignMiamiPage } from "./pages/InvisalignMiamiPage";
import { LifeWithBracesPage } from "./pages/LifeWithBracesPage";
import { MiamiBracesPage } from "./pages/MiamiBracesPage";
import { MiamiFamilyOrthodontistPage } from "./pages/MiamiFamilyOrthodontistPage";
import { MiamiInvisalignPage } from "./pages/MiamiInvisalignPage";
import { MiamiOrthodonticsPage } from "./pages/MiamiOrthodonticsPage";
import { OrthoCarePage } from "./pages/OrthoCarePage";
import { OrthoEmergenciesPage } from "./pages/OrthoEmergenciesPage";
import { OrthoInfoPage } from "./pages/OrthoInfoPage";
import { SmileBestMedicinePage } from "./pages/SmileBestMedicinePage";
import { TermsConditionsPage } from "./pages/TermsConditionsPage";
import { TestimonialsPage } from "./pages/TestimonialsPage";
import { ThankYouPage } from "./pages/ThankYouPage";
import { TheDemolitionIsRealPage } from "./pages/TheDemolitionIsRealPage";
import { WelcomeMiamiOrthodonticsPage } from "./pages/WelcomeMiamiOrthodonticsPage";
import { WhyIBecameOrthodontistPage } from "./pages/WhyIBecameOrthodontistPage";
import { YourMiamiOrthodontistPage } from "./pages/YourMiamiOrthodontistPage";

type LiveSeoPageProps = { page: LiveSeoPageData };

// The router splits this route's component. Keep its renderers static so their
// CSS is linked during SSR and navigation cannot reveal an empty inner boundary.
const liveSeoRenderers: Record<string, ComponentType<LiveSeoPageProps>> = {
	"/accessibility-statement": AccessibilityStatementPage,
	"/blog": BlogPage,
	"/careers": CareersPage,
	"/contact-us": ContactPage,
	"/covid-19": CovidPage,
	"/faqs": FaqsPage,
	"/terms-conditions": TermsConditionsPage,
	"/happy-halloween": HappyHalloweenPage,
	"/invisalign-miami": InvisalignMiamiPage,
	"/miami-braces": MiamiBracesPage,
	"/miami-family-orthodontist": MiamiFamilyOrthodontistPage,
	"/miami-invisalign": MiamiInvisalignPage,
	"/miami-orthodontics": MiamiOrthodonticsPage,
	"/ortho-care": OrthoCarePage,
	"/ortho-emergencies": OrthoEmergenciesPage,
	"/ortho-info": OrthoInfoPage,
	"/life-with-braces": LifeWithBracesPage,
	"/testimonials": TestimonialsPage,
	"/thank-you": () => <ThankYouPage titleKey="title" />,
	"/thanks": () => <ThankYouPage titleKey="thanksTitle" />,
	"/the-demolition-is-real": TheDemolitionIsRealPage,
	"/smile-best-medicine": SmileBestMedicinePage,
	"/welcome-miami-orthodontics": WelcomeMiamiOrthodonticsPage,
	"/why-i-became-an-orthodontist": WhyIBecameOrthodontistPage,
	"/your-miami-orthodontist": YourMiamiOrthodontistPage,
};

export function LiveSeoPage({ page }: LiveSeoPageProps) {
	const Page = liveSeoRenderers[page.path] ?? DefaultLiveSeoPage;
	return <Page page={page} />;
}
